var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5013 0.833984V2.50065H12.5013V0.833984H14.168V2.50065H17.5013C17.9616 2.50065 18.3346 2.87375 18.3346 3.33398V16.6673C18.3346 17.1276 17.9616 17.5007 17.5013 17.5007H2.5013C2.04107 17.5007 1.66797 17.1276 1.66797 16.6673V3.33398C1.66797 2.87375 2.04107 2.50065 2.5013 2.50065H5.83464V0.833984H7.5013ZM16.668 9.16732H3.33464V15.834H16.668V9.16732ZM5.83464 4.16732H3.33464V7.50065H16.668V4.16732H14.168V5.83398H12.5013V4.16732H7.5013V5.83398H5.83464V4.16732Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLine);
export default __webpack_public_path__ + "static/media/calendar-line.11d513472068c144c45c7848045f1554.svg";
export { ForwardRef as ReactComponent };